<template>
    <div class="layout-type field-wrap">
        <ul class="layout-type__list">
            <li
                v-for="(options__value, options__key) in options"
                v-bind:key="id + '_' + options__key"
                class="layout-type__list-element"
            >
                <span
                    class="layout-type__num"
                    v-html="'#' + ('000' + (options__key + 1)).slice(-3)"
                ></span>
                <input
                    type="radio"
                    :id="id + '_' + options__key"
                    v-model="simpleFieldModel"
                    :value="Array.isArray(options) ? options__value : options__key"
                    class="layout-type__input"
                />
                <label :for="id + '_' + options__key" class="layout-type__label">
                    <span class="layout-type__pseudo-radio"></span>
                    <img
                        v-bind:src="
                            generateMediaUrl({ path: getThumbnailPath(options__value), w: 400 })
                        "
                        alt=""
                        class="layout-type__image"
                    />
                </label>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import pushid from 'pushid';
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';

export default {
    data() {
        return {
            id: pushid()
        };
    },
    components: {},
    methods: {
        getThumbnailPath(id) {
            let path = '';
            path +=
                'static/ui/layouts/' +
                (this.getActiveModuleType || this.getActiveMenuType) +
                '/' +
                id;
            let align = this.getProp(this.dataSource.replace('.type', '.align'));
            if (align !== undefined && align !== null && align !== '') {
                path += '_' + align;
            }
            path += '.svg';
            return path;
        }
    },
    computed: {
        ...mapGetters(['getProp', 'generateMediaUrl', 'getActiveModuleType', 'getActiveMenuType'])
    },
    mixins: [SimpleFieldMixin],
    mounted() {},
    props: {
        options: [Object, Array]
    }
};
</script>
